import React from "react";
import { Tooltip, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
export const formatMetricStrings = (
  value: string | number | boolean,
  type: "pct" | "dist" | "str" | "bool",
  metricKey: string,
  isApproximate: boolean,
) => {
  if (value === null || value === undefined)
    return (
      <Tooltip title="No data available" enterTouchDelay={0}>
        <Typography>{"N/A"}</Typography>
      </Tooltip>
    );

  switch (type) {
    case "pct":
      {
        if (typeof value === "number")
          return (
            <Typography
              sx={{
                fontSize: { xs: "1.5rem", md: "1.25rem", lg: "1.5rem" },
                fontFamily: "Bebas Neue",
                letterSpacing: 1,
              }}
            >
              {isApproximate ? "~" : ""}
              {`${Math.round(value * 100)}`}
              <span style={{ fontFamily: "Montserrat", fontSize: "1rem" }}>
                %
              </span>
            </Typography>
          );
      }
      break;
    case "dist":
      {
        if (typeof value === "number")
          return (
            <Typography
              sx={{
                fontSize: { xs: "1.5rem", md: "1.25rem", lg: "1.5rem" },
                fontFamily: "Bebas Neue",
                letterSpacing: 1,
              }}
            >
              {`${Math.round(10 * value) / 10}`}
              <span style={{ fontFamily: "Montserrat", fontSize: "1rem" }}>
                {" mi"}
              </span>
            </Typography>
          );
      }
      break;
    case "str":
      return value.toString().indexOf("(optimal)") >= 0 ? (
        <Typography
          sx={{
            fontSize: { xs: "1.5rem", md: "1.25rem", lg: "1.5rem" },
            fontFamily: "Bebas Neue",
            letterSpacing: 1,
          }}
        >
          {`${value
            .toString()
            .slice(0, value.toString().indexOf("(optimal)"))}`}
          <br />
          <span
            style={{
              fontFamily: "Montserrat",
              fontSize: ".875rem",
              fontStyle: "italic",
            }}
          >
            {"Optimal"}
          </span>
        </Typography>
      ) : (
        <Typography
          sx={{
            fontSize: { xs: "1.25rem", md: "1.25rem", lg: "1.5rem" },
            fontFamily: "Bebas Neue",
            letterSpacing: 1,
          }}
        >
          {isApproximate ? "~" : ""}

          {value}
        </Typography>
      );
    case "bool":
      {
        return (
          <Typography
            sx={{
              fontSize: { xs: "1.25rem", md: "1.25rem", lg: "1.5rem" },
              fontFamily: "Bebas Neue",
              letterSpacing: 1,
            }}
          >
            {value ? (
              <CheckCircleIcon color="success" />
            ) : (
              <HighlightOffIcon color="warning" />
            )}
          </Typography>
        );
      }
      break;
    default:
      throw new Error(`Metric "${metricKey}" does not have formatter`);
  }
};
